"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewActionsController = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const findFilterByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findFilterByKey"));
const findGroupByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByKey"));
const findGroupByType_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByType"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const utils_1 = require("@opsbase/lib-time/utils");
const react_1 = __importStar(require("react"));
const ViewActionsContext_1 = __importDefault(require("../useViewActions/ViewActionsContext"));
const useViewRegistryActions_1 = __importDefault(require("../useViewRegistryActions"));
function ViewActionsController({ children }) {
    const { getView, setView, cloneView } = (0, useViewRegistryActions_1.default)();
    const addFilter = (0, react_1.useCallback)((viewId) => (filter) => {
        const view = cloneView(viewId);
        const alreadyExists = (0, findFilterByKey_1.default)(view.filters, filter.queryFieldKey, filter.id);
        if (!alreadyExists) {
            // If the filter is associated with one of our Group Bys
            // Then we the groups have potentially changed
            if ((0, findGroupByKey_1.default)(view.groupBys, filter.queryFieldKey)) {
                view.groupsChanged = new Date();
            }
            // Otherwise, just the data has potentially changed
            else {
                view.filtersChanged = new Date();
            }
            view.filters = [...view.filters, filter]; // New array to trigger a change
            setView(view);
        }
    }, [cloneView, setView]);
    const removeFilter = (0, react_1.useCallback)((viewId) => (filter) => {
        const view = cloneView(viewId);
        // If the filter is associated with one of our Group Bys
        // Then we the groups have potentially changed
        if ((0, findGroupByKey_1.default)(view.groupBys, filter.queryFieldKey)) {
            view.groupsChanged = new Date();
        }
        // Otherwise, just the data has potentially changed
        else {
            view.filtersChanged = new Date();
        }
        view.filters = view.filters.filter(fb => !(fb.id === filter.id && fb.queryFieldKey === filter.queryFieldKey)); // New array to trigger a change
        setView(view);
    }, [cloneView, setView]);
    const toggleFilter = (0, react_1.useCallback)((viewId) => (filter) => {
        var _a;
        const fs = getView(viewId).filters;
        const isDate = ((_a = QueryFieldRegistry_1.default[filter.queryFieldKey]) === null || _a === void 0 ? void 0 : _a.fieldType) === BasicFieldType_1.default.DATE;
        const found = isDate
            ? fs.find(fb => fb.queryFieldKey === filter.queryFieldKey)
            : fs.find(fb => fb.queryFieldKey === filter.queryFieldKey && fb.id === filter.id);
        if (found)
            removeFilter(viewId)(filter);
        if (!found || isDate)
            addFilter(viewId)(filter);
    }, [addFilter, removeFilter, getView]);
    const setFilters = (0, react_1.useCallback)((viewId) => (filters) => {
        const view = cloneView(viewId);
        view.groupsChanged = new Date();
        view.filters = filters;
        setView(view);
    }, [cloneView, setView]);
    const shiftDateFilter = (0, react_1.useCallback)((viewId) => (queryFieldKey, amount) => {
        const view = cloneView(viewId);
        view.filtersChanged = new Date();
        const filter = (0, findFilterByKey_1.default)(view.filters, queryFieldKey);
        if (filter) {
            view.filters = view.filters.filter(fb => fb.queryFieldKey !== queryFieldKey);
            const diff = filter.to.diff(filter.from, 'day');
            if (amount > 0) {
                filter.from = filter.to.clone().add(1, 'day').startOf('day');
                filter.to = filter.from
                    .clone()
                    .add(amount * diff, 'day')
                    .endOf('day');
            }
            else {
                filter.to = filter.from.clone().add(-1, 'day').endOf('day');
                filter.from = filter.to
                    .clone()
                    .add(amount * diff, 'day')
                    .startOf('day');
            }
            filter.title = (0, utils_1.titleFromDateRange)(filter.from, filter.to);
            delete filter.interval;
            view.highlightedDateRange = undefined;
            view.filters.push(filter);
            setView(view, false);
        }
    }, [cloneView, setView]);
    const resetHideEmptyGroups = (0, react_1.useMemo)(() => (view, groupBys) => {
        const canHideEmptyGroups = !!groupBys &&
            !((0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.RELATED_MODEL) ||
                (0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.STRING) ||
                (0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.DATE));
        if (!canHideEmptyGroups)
            view.hideEmptyGroups = false;
    }, []);
    const addGroupBy = (0, react_1.useCallback)((viewId) => (groupBy) => {
        const view = cloneView(viewId);
        view.groupsChanged = new Date();
        if (!(0, findGroupByKey_1.default)(view.groupBys, groupBy.queryFieldKey)) {
            view.groupBys = [...view.groupBys, groupBy]; // New array to trigger a change
            resetHideEmptyGroups(view, view.groupBys);
            setView(view);
        }
    }, [cloneView, setView, resetHideEmptyGroups]);
    const removeGroupBy = (0, react_1.useCallback)((viewId) => (groupBy) => {
        const view = cloneView(viewId);
        view.groupsChanged = new Date();
        view.highlightedGroups = [];
        view.groupBys = view.groupBys.filter(gb => gb.queryFieldKey !== groupBy.queryFieldKey); // New array to trigger a change
        setView(view);
    }, [cloneView, setView]);
    const setGroupBys = (0, react_1.useCallback)((viewId) => (groupBys) => {
        const view = cloneView(viewId);
        view.groupsChanged = new Date();
        view.groupBys = [...groupBys];
        resetHideEmptyGroups(view, groupBys);
        setView(view);
    }, [cloneView, setView, resetHideEmptyGroups]);
    const toggleGroupBy = (0, react_1.useCallback)((viewId) => (groupBy) => {
        const view = getView(viewId);
        const found = (0, findGroupByKey_1.default)(view.groupBys, groupBy.queryFieldKey);
        if (found)
            removeGroupBy(viewId)(groupBy);
        else
            addGroupBy(viewId)(groupBy);
    }, [addGroupBy, removeGroupBy, getView]);
    const addField = (0, react_1.useCallback)((viewId) => (field) => {
        const view = cloneView(viewId);
        view.fieldsChanged = new Date();
        view.fields = [...view.fields]; // New array to trigger a change
        const existing = view.fields.find(f => f.key === field.key);
        if (!existing) {
            view.fields.push(field);
        }
        else {
            Object.assign(existing, field);
        }
        setView(view, false);
    }, [cloneView, setView]);
    const removeField = (0, react_1.useCallback)((viewId) => (field) => {
        const view = cloneView(viewId);
        view.fieldsChanged = new Date();
        view.fields = view.fields.filter(f => f.key !== field.key); // New array to trigger a change
        setView(view, false);
    }, [cloneView, setView]);
    const setFields = (0, react_1.useCallback)((viewId) => (fields) => {
        const view = cloneView(viewId);
        view.fieldsChanged = new Date();
        view.fields = [...fields]; // New array to trigger a change
        setView(view, false);
    }, [cloneView, setView]);
    const toggleField = (0, react_1.useCallback)((viewId) => (field) => {
        const fs = getView(viewId).fields;
        const found = fs.find(f => f.key === field.key);
        if (found)
            removeField(viewId)(field);
        else
            addField(viewId)(field);
    }, [addField, removeField, getView]);
    const moveField = (0, react_1.useCallback)((viewId) => (oldIndex, newIndex) => {
        const view = cloneView(viewId);
        const fs = [...view.fields]; // New array to trigger a change
        const field = fs[oldIndex];
        fs.splice(oldIndex, 1);
        fs.splice(newIndex, 0, field);
        view.fields = fs;
        setView(view, false);
    }, [cloneView, setView]);
    const setReportPage = (0, react_1.useCallback)((viewId) => (page) => {
        const view = cloneView(viewId);
        view.groupsChanged = new Date();
        view.highlightsChanged = new Date();
        view.highlightedGroups = [];
        view.reportPage = page;
        setView(view, false);
    }, [cloneView, setView]);
    const setSortBy = (0, react_1.useCallback)((viewId) => (field, desc) => {
        const view = cloneView(viewId);
        view.sortingChanged = new Date();
        view.sortBy = field;
        view.sortByDesc = desc;
        setView(view, false);
    }, [cloneView, setView]);
    const setPinField = (0, react_1.useCallback)((viewId) => (field) => {
        const view = cloneView(viewId);
        view.pinningChanged = new Date();
        view.pinField = field;
        setView(view, false);
    }, [cloneView, setView]);
    const toggleHighlightedGroup = (0, react_1.useCallback)((viewId) => (group, force) => {
        const view = cloneView(viewId);
        view.highlightsChanged = new Date();
        const found = view.highlightedGroups.find(h => h.queryFieldKey === group.queryFieldKey && h.id === group.id);
        view.highlightedGroups = view.highlightedGroups.filter(h => h.queryFieldKey !== group.queryFieldKey); // New array to trigger a change
        if (!found || force)
            view.highlightedGroups.push(group);
        setView(view, false);
    }, [cloneView, setView]);
    const toggleHighlightedDateRange = (0, react_1.useCallback)((viewId) => (v, force) => {
        const view = cloneView(viewId);
        view.highlightsChanged = new Date();
        const h = view.highlightedDateRange;
        if (!force && (h === null || h === void 0 ? void 0 : h.key) === (v === null || v === void 0 ? void 0 : v.key) && (h === null || h === void 0 ? void 0 : h.from.isSame(v.from)) && (h === null || h === void 0 ? void 0 : h.to.isSame(v.to)))
            view.highlightedDateRange = undefined;
        else
            view.highlightedDateRange = v;
        setView(view, false);
    }, [cloneView, setView]);
    const toggleHighlightedField = (0, react_1.useCallback)((viewId) => (field, force) => {
        var _a;
        const view = cloneView(viewId);
        view.highlightsChanged = new Date();
        view.highlightedField = force
            ? field
            : ((_a = view.highlightedField) === null || _a === void 0 ? void 0 : _a.key) === (field === null || field === void 0 ? void 0 : field.key)
                ? null
                : field;
        setView(view, false);
    }, [cloneView, setView]);
    const toggleHighlightedItem = (0, react_1.useCallback)((viewId) => (item, force) => {
        const view = cloneView(viewId);
        view.highlightsChanged = new Date();
        view.highlightedItem = force ? item : view.highlightedItem === item ? null : item;
        setView(view, false);
    }, [cloneView, setView]);
    const toggleChartBox = (0, react_1.useCallback)((viewId) => (visible) => {
        const view = cloneView(viewId);
        view.chartBox = Object.assign(Object.assign({}, view.chartBox), { visible }); // New object to trigger a change
        setView(view, false);
    }, [cloneView, setView]);
    const updateChart = (0, react_1.useCallback)((viewId) => (chart) => {
        const view = cloneView(viewId);
        view.chartsChanged = new Date();
        view.chartBox = {
            visible: view.chartBox.visible,
            charts: view.chartBox.charts.map(c => (c.key !== chart.key ? c : chart)),
        };
        setView(view, false);
    }, [cloneView, setView]);
    const setChartBox = (0, react_1.useCallback)((viewId) => (chartBox) => {
        const view = cloneView(viewId);
        view.chartsChanged = new Date();
        view.chartBox = chartBox;
        setView(view);
    }, [cloneView, setView]);
    const setHideEmptyGroups = (0, react_1.useCallback)((viewId) => (hide) => {
        const view = cloneView(viewId);
        view.hideEmptyGroups = hide;
        setView(view);
    }, [cloneView, setView]);
    const refresh = (0, react_1.useCallback)((viewId) => () => {
        const view = cloneView(viewId);
        view.groupsChanged = new Date();
        setView(view);
    }, [cloneView, setView]);
    const setBooleanFilter = (0, react_1.useCallback)((viewId) => (qfk, v) => {
        const view = cloneView(viewId);
        view.filters = view.filters.filter(f => f.queryFieldKey !== qfk);
        if (v)
            view.filters.push({
                queryFieldKey: qfk,
                id: 'TRUE',
                hidden: true,
                veryHidden: true,
            });
        view.filtersChanged = new Date();
        setView(view);
    }, [cloneView, setView]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        addFilter,
        removeFilter,
        toggleFilter,
        setBooleanFilter,
        setFilters,
        shiftDateFilter,
        addGroupBy,
        removeGroupBy,
        toggleGroupBy,
        setGroupBys,
        addField,
        removeField,
        toggleField,
        setFields,
        moveField,
        setReportPage,
        setSortBy,
        setPinField,
        setHideEmptyGroups,
        toggleHighlightedGroup,
        toggleHighlightedDateRange,
        toggleHighlightedField,
        toggleHighlightedItem,
        toggleChartBox,
        setChartBox,
        updateChart,
        refresh,
    }), [
        addField,
        addGroupBy,
        addFilter,
        setBooleanFilter,
        moveField,
        refresh,
        removeField,
        removeGroupBy,
        removeFilter,
        setChartBox,
        setFields,
        setFilters,
        setGroupBys,
        setHideEmptyGroups,
        setReportPage,
        setSortBy,
        setPinField,
        shiftDateFilter,
        toggleChartBox,
        toggleField,
        toggleGroupBy,
        toggleHighlightedDateRange,
        toggleHighlightedField,
        toggleHighlightedGroup,
        toggleHighlightedItem,
        toggleFilter,
        updateChart,
    ]);
    return react_1.default.createElement(ViewActionsContext_1.default.Provider, { value: actionsCtx }, children);
}
exports.ViewActionsController = ViewActionsController;
exports.default = ViewActionsController;
